export function listConfig(params) {
    return window.axios.post("api/config/list", params)
}

export function deleteConfig(id) {
    return window.axios.post("api/config/delete", {id: id})
}

export function updateConfig(params) {
    return window.axios.post("api/config/update", params)
}

export function addConfig(params) {
    return window.axios.post("api/config/add", params)
}

export function getConfig(id) {
    return window.axios.post("api/config/get", {id: id})
}

export function getByUserId(params) {
    return window.axios.post("api/config/getByUserId", params)
}
export function getExportByUserId(params) {
    return window.axios.post("api/exportConfig/getByUserId", params)
}

export function setData(params) {
    return window.axios.post("api/config/setData", params)
}
export function setExportData(params) {
    return window.axios.post("api/exportConfig/setData", params)
}
